// Copyright 2022-2024, 2026 - Hewlett Packard Enterprise Company
import { Box, Button, Heading, Layer, Notification, Text } from 'grommet';
import { useTranslation } from 'react-i18next';

export default function ServerSettingDeletedModal({ serverSettings, onClose }) {
  const { t } = useTranslation('common');
  return (
    <Layer
      as="section"
      position="center"
      modal
      onClickOutside={onClose}
      onEsc={onClose}
    >
      <Box gap="none" pad="medium" width="586px">
        <>
          <Heading level={2} margin="none" truncate>
            {serverSettings}
          </Heading>
          <Box data-testid="notification-wrapper" pad={{ vertical: '3xsmall' }}>
            <Notification
              status="warning"
              message={
                <Box>
                  <Text size="large">
                    {t('settings_detail_page.deleted_control.msg')}
                  </Text>
                </Box>
              }
            />
          </Box>
        </>
        <Box justify="end" direction="row">
          <Button
            label={t('settings_detail_page.deleted_control.close_btn_label')}
            onClick={onClose}
            primary
          />
        </Box>
      </Box>
    </Layer>
  );
}
